module.exports = __webpack_public_path__ + "static/img/dynamicf.44e6ee0.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/dynamicf.png
// module id = Crpt
// module chunks = 45